export default "__VITE_ASSET__DE0fJW5l__"